import styled from 'styled-components';

// lego
import { Dropdown as legoDropdown } from 'lego-dist';

export const Dropdown = styled(legoDropdown)`
  padding: 0;

  & #DropdownRemove-content {
    padding: 0;
    max-width: 157px;
  }
`;

Dropdown.displayName = 'SettingsMemberProfileDeleteMemberDropdown';

export const DropdownItem = styled.div`
  display: block;
  cursor: pointer;
  text-align: center;
  padding: 10px 16px 10px 12px;
`;

DropdownItem.displayName = 'SettingsMemberProfileDeleteMemberDropdownItem';
